import type {
  FileCategory,
  GetPresignedPayload,
  GetPresignedURLResponse,
} from "@/types/files";
import type { AxiosProgressEvent } from "axios";

export function getPreSignedUploadUrl(files: GetPresignedPayload[]) {
  return usePutRequest<{ response: GetPresignedURLResponse[] }>("/account/files", {
    files,
  });
}

export async function getPreSignedDownloadUrl(
  id: string,
  type: FileCategory = "mediaAssets"
) {
  const res = await useGetRequest<{ path: string }>("/account/files", {
    params: { id, type },
  });

  return res.data;
}

export function uploadFile(
  url: string,
  formData: FormData,
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
) {
  return baseAxiosInstance.post(url, formData, { onUploadProgress });
}
